export const RESULTS_PER_BATCH = 100;
export const MAX_RESULTS_PER_PAGE = 20;
export const NUMBER_OF_VISIBLE_PAGES = RESULTS_PER_BATCH / MAX_RESULTS_PER_PAGE;
